import MyTable from "components/UIElements/MyTable";


export default function Sms({ endPoint ,exportFilename }) {

    const columns = [
        {
            title: 'PolicyNo',
            key: 'policyNumber',
            dataIndex: 'policyNumber',
        },
        {
            title: 'PlateNo',
            key: 'plateNumber',
            dataIndex: 'plateNumber',
        },
        {
            title: 'OBD_Imei',
            key: 'deviceImei',
            dataIndex: 'deviceImei',
        },
        {
            title: 'Channel',
            key: 'channel',
            dataIndex: 'channel'
        },
        {
            title: 'Surname',
            key: 'lastName',
            dataIndex: 'lastName',
        },
        {
            title: 'Name',
            key: 'firstName',
            dataIndex: 'firstName',
        },
        {
            title: 'Start_Contract',
            key: 'contractStartDate',
            dataIndex: 'contractStartDate',
        },
        {
            title: 'End_Contract',
            key: 'contractEndDate',
            dataIndex: 'contractEndDate',
        },
        {
            title: ' Issued_Date',
            key: 'dateCreated',
            dataIndex: 'dateCreated',
        },
        {
            title: 'Code_SMS',
            key: 'smsType',
            dataIndex: 'smsType',
        },
        {
            title: 'Status_SMS',
            key: 'status',
            dataIndex: 'status',
        },
        {
            title: 'Context_SMS',
            key: 'smsContent',
            dataIndex: 'smsContent',
        },
    ]

    return <MyTable columns={columns} endPoint={endPoint}  exportFilename={exportFilename}/>
}